import React from 'react';
import './ComingSoon.css';

const Videos = () => {
  return (
    <div className="coming-soon-container">
      <div className="coming-soon-content">
        <span className="coming-soon-icon">🎥</span>
        <h1>Video Tutorials</h1>
        <p>Educational videos and trading tutorials coming soon!</p>
      </div>
    </div>
  );
};

export default Videos;
